<div class="IL_scac_container assessment-section" [ngClass]="action">    
    <ng-container *ngIf="dataFetched">    
        <div class="IL_scac_content_box" [class.zero-items]="!tests.length">
            <div class="IL_scac_content_blue_hood"></div>
            <div class="IL_scac_content" [class.step3]="step == 3">
                <div class="IL_scac_no_content" *ngIf="!tests.length; else testsGrid">    
                    <div class="page_name">
                        {{actionDesc}}
                    </div>
                    <div class="welcome_note">
                        Welcome back - &nbsp;<b>{{userData.firstName}} {{userData.lastName}}</b>
                    </div>
                    <div class="warning_indicator">
                        !
                    </div>
                    <div class="warning_msg">
                        {{noTestMsg}}
                    </div>
                </div>
                <ng-template #testsGrid>
                    <div class="IL_scac_tests_grid">    
                        <div class="page_name">
                            <div class="UNFAPP-signlog-hdng-wrap">
                                <h2 class="UNFAPP-signlog-hdng">{{actionDesc}}</h2>
                            </div>
                            
                        </div>
                        <div class="steps_bar" *ngIf="action == 'reschedule'">
                            <div class="step one complete">
                                1
                                <div class="step_desc">
                                    Verify OTP
                                </div>
                            </div>
                            <div class="step_sep">

                            </div>
                            <div class="step two" [ngClass]="{complete: step == 3, active: step == 2}">
                                2
                                <div class="step_desc">
                                    Select Test
                                </div>
                            </div>
                            <div class="step_sep">

                            </div>
                            <div class="step three" [ngClass]="{ active: step == 3}">
                                3
                                <div class="step_desc">
                                    Reschedule
                                </div>
                            </div>
                        </div>
                        <div class="welcome_note">
                            <p class="resc-welc">Welcome back - <span class="resc-name">{{userData.firstName}} {{userData.lastName}}</span></p>
                            <!-- Welcome back - &nbsp;<b>{{userData.firstName}} {{userData.lastName}}</b> -->
                        </div>
                        <ng-container *ngIf="step == 2; else step3Block">    
                            <div class="test_cards" [ngClass]="tests?.length>2?'':'center_cards'" >
                                <div class="test_card" *ngFor="let test of tests">
                                    <div class="test_card_header">
                                        {{test?.exam}}
                                    </div>
                                    <div class="test_card_info">
                                        <div class="info_itemheight">
                                            <div class="info_item">
                                                Grade <div class="info_item_value">{{test?.grade}}</div>
                                            </div>
                                            <div class="info_item">
                                                Mode of exam <div class="info_item_value"><span *ngIf="test?.isoffline || HallticketisOffline">Offline</span><span *ngIf="!test?.isoffline && !HallticketisOffline">Online</span></div>
                                            </div>
                                            <div class="info_item">
                                                Target Exam <div class="info_item_value">{{test?.exam}}</div>
                                            </div>
                                            <div class="info_item" *ngIf="rescheduleOnlineOffline || HallticketisOffline || (test?.isSubmitted && !test?.isoffline)">
                                                Date of exam <div class="info_item_value">{{test?.date || (test?.examsubmittedon | date:'d MMM, YYYY')}}</div>
                                            </div>
                                            <div class="info_item" *ngIf="(HallticketisOffline || rescheduleOnlineOffline) && !test?.isSubmitted">
                                                Time of exam <div class="info_item_value">{{test.time || (test?.examsubmittedon | date:'h:mm a')}}</div>
                                            </div>
                                            <div class="info_item" *ngIf="test?.isSubmitted && !test?.isoffline">
                                                Time of exam <div class="info_item_value">{{(test?.isoffline ? test?.span : test?.examstartedon) | date:'h:mm a'}} <span *ngIf="test?.examstartedon || test?.span">to</span> {{(test?.examSubmittedTime | date:'h:mm a')}}</div>
                                            </div>   
                                        </div>                                     
                                        <div class="test_card_action" (click)="handleAction(test)" *ngIf="action == 'attempt'; else otherActions">
                                            {{test.status != 'attempt' ?  'Enrolled': ( test.isExamInProgress ? 'Resume Now':'Attempt Now')}}
                                        </div>
                                        <ng-template #otherActions>
                                            <div class="test_card_action" (click)="downloadReport(test)"  *ngIf="action === 'participation'">
                                                Download Test Report
                                            </div>
                                            <div [ngClass]="action === 'participation' ? 'participation_action' : 'test_card_action' " *ngIf="(test?.timediffrence >= 1 || !test?.timediffrence) && test?.timediffrence !=0 && !test?.isPast" (click)="handleAction(test)">
                                                {{actionClickText}}
                                            </div>
                                            <div class="reschedule_action" *ngIf="(test?.timediffrence < 1 && test?.timediffrence <=0) || test?.isPast" data-toggle="tooltip" data-placement="top" title="{{tooltip}}">
                                                {{actionClickText}}
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <!-- <ng-template #step3Block>
                            <div class="info_item" *ngIf="rescheduleTime < 3">
                                <p>below 72 hours</p>
                            </div>  
                            <div *ngIf="gradesFetched && rescheduleTime >=3" class="reschedule_form" [formGroup]="rescheduleForm">
                                <div>
                                    Select your current Grade
                                 </div>   
                                 <select class="grades_dropdown" (change)="selectedGrade()" formControlName="grade">
                                    <option value="" disabled>Select Grade</option>
                                    <option *ngFor="let grade of grades" [value]="grade.gradeId">Grade {{grade.name.slice(0,-2)}}</option>
                                 </select>
                                 <div class="assessment_mt-20" *ngIf="rescheduleFormControls.grade.value != ''">
                                    Select your target Exam
                                 </div>
                                 <div class="exam_cards" *ngIf="rescheduleFormControls.grade.value != ''">
                                    <div *ngIf='selectedGradeName == "1st" ||selectedGradeName == "2nd" || selectedGradeName == "3rd" || selectedGradeName == "4th"|| selectedGradeName == "5th"' [class.active]="rshdForm.exam.value == 'APTITUDETEST'" (click)="changeFormValue('exam', 'APTITUDETEST')">
                                        APTITUDE TEST
                                    </div>
                                    <div *ngIf='selectedGradeName == "6th" || selectedGradeName == "7th" || selectedGradeName == "8th"' [class.active]="rshdForm.exam.value == 'FOUNDATIONTEST'" (click)="changeFormValue('exam', 'FOUNDATIONTEST')">
                                        FOUNDATION TEST
                                    </div>
                                     <div *ngIf='selectedGradeName == "9th"|| selectedGradeName =="10th" ||selectedGradeName == "11th" || selectedGradeName == "12th" || selectedGradeName == "13th"' [class.active]="rshdForm.exam.value == 'NEET'" (click)="changeFormValue('exam', 'NEET')">
                                        NEET
                                     </div>
                                     <div *ngIf='selectedGradeName == "9th"|| selectedGradeName =="10th" ||selectedGradeName == "11th" || selectedGradeName == "12th" || selectedGradeName == "13th"' class="assessment_ml-15 assessment_mr-15" [class.active]="rshdForm.exam.value == 'JEEMAIN'" (click)="changeFormValue('exam', 'JEEMAIN')">
                                        JEE
                                    </div>                                    
                                 </div>
                                <div class=" assessment_mt-20 slots_block" *ngIf="rescheduleFormControls.exam.value != ''">
                                    
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="YourMobilenumber" class="nsonlinelabel">State</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <select class="UNFAPP-form-fld" name="state" id="state" required="required" [value]="rescheduleFormControls.state.value" (change)="selectState($event)">
                                                    <option value="" disabled>Select State</option>
                                                    <option [value]="state" *ngFor="let state of pincodefilteredStates">{{state}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="YourMobilenumber" class="nsonlinelabel">City</label>
                                            <div class="UNFAPP-form-fld-wrp">
                                                <select class="UNFAPP-form-fld" name="city" id="city" required="required" [value]="rescheduleFormControls.city.value" (change)="selectCity($event)">
                                                    <option value="" disabled>Select City</option>
                                                    <ng-container *ngIf="rescheduleFormControls.state.value != ''">
                                                        <option *ngFor="let city of pincodefilteredCities; let i=index" [value]="city">
                                                            {{city}}
                                                        </option>
                                                    </ng-container>
                                                </select>
                                            </div>
                                        </div>
                                </div>
                                <div class="assessment_mt-20" *ngIf="rescheduleFormControls.exam.value != ''">
                                    Mode of exam
                                 </div>
                                 <div class="exam_modes" *ngIf="rescheduleFormControls.exam.value != ''">
                                    <div [class.active]="rshdForm.mode.value == 'Offline'" (click)="changeFormValue('mode', 'Offline')" *ngIf="filteredCenters?.length>0">
                                        Offline
                                   </div>  
                                    <div class="assessment_ml-15" [class.active]="rshdForm.mode.value == 'Online'" (click)="changeFormValue('mode', 'Online')">
                                        Online
                                   </div> 
                                </div>
                                <div class=" assessment_mt-20 slots_block" *ngIf="rescheduleFormControls.exam.value != '' && rescheduleFormControls.mode.value != '' && rescheduleFormControls.mode.value == 'Offline'">
                                    <div class="UNFAPP-form-fld-row">
                                        <label for="YourMobilenumber" class="nsonlinelabel">Center</label>
                                        <div class="UNFAPP-form-fld-wrp ">
                                            <select class="UNFAPP-form-fld" name="date" id="date" required="required" [value]="rescheduleFormControls.center.value" (change)="centerChange($event)">
                                                <option value="" disabled>Select Center</option>
                                                <option [value]="center" *ngFor="let center of filteredCenters">{{center}}</option>
                                            </select>
                                        </div>
                                    </div>
                            </div>
                                <div class="assessment_mt-20 slots_block" *ngIf="rescheduleFormControls.mode.value === 'Offline' && rescheduleFormControls.center.value != ''">
                                    <div>
                                        Date
                                        <select [value]="rshdForm.date.value" (change)="selectSlotDate($event)">
                                            <option value="" disabled>Select Date</option>
                                            <option [value]="dt" *ngFor="let dt of dates; let i = index">{{dt}} ({{dateDayarr[i]}})</option>
                                        </select>
                                    </div>
                                    <div>
                                        Time
                                        <select  [value]="rshdForm.ruleid.value" (change)="selectSlotTime($event)">
                                            <option value="" disabled>Select Time</option>
                                                <option *ngFor="let tm of times[rshdForm.date.value]; let i = index" [value]="tm.ruleid">
                                                    {{tm.time}} - {{tm?.duration | date: 'hh:mm a'}}
                                                </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </ng-template> -->
                        <ng-template #step3Block>
                            <!-- <div class="info_item" *ngIf="rescheduleTime < 3">
                                <p>This test can't be rescheduled. You can reschedule tests only 72 hours before the exam date and time.</p>
                            </div>   -->
                            <div *ngIf="gradesFetched" class="reschedule_form" [formGroup]="rescheduleForm">
                                <div class="row">
                                    <div class="col-md-6 col-lg-6 col-12">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="grade" class="nsonlinelabel">Select your desired Grade</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <select class="UNFAPP-form-fld" name="grade" id="grade" required="required" (change)="selectedGrade()" formControlName="grade">
                                                    <option value="" disabled>Select Grade</option>
                                                    <option *ngFor="let grade of grades" [value]="grade.gradeId">Grade {{grade.name.slice(0,-2)}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.grade.value != ''">
                                    <div class="col-md-12 col-lg-12 col-12">
                                        <label for="Targetexam" class="nsonlinelabel">Select your Target Exam</label>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-6">
                                                <div class="UNFAPP-form-fld-wrp ">
                                                    <button class="ns-cour-radiobx" *ngIf='selectedGradeName == "1st" ||selectedGradeName == "2nd" || selectedGradeName == "3rd" || selectedGradeName == "4th"|| selectedGradeName == "5th"' [class.active]="rshdForm.exam.value == 'APTITUDETEST'" (click)="changeFormValue('exam', 'APTITUDETEST')">
                                                        APTITUDE TEST
                                                    </button>
                                                    <button class="ns-cour-radiobx" *ngIf='selectedGradeName == "6th" || selectedGradeName == "7th" || selectedGradeName == "8th"' [class.active]="rshdForm.exam.value == 'FOUNDATIONTEST'" (click)="changeFormValue('exam', 'FOUNDATIONTEST')">
                                                        FOUNDATION TEST
                                                    </button>
                                                    <button class="ns-cour-radiobx active" *ngIf='selectedGradeName == "9th"|| selectedGradeName =="10th" ||selectedGradeName == "11th" || selectedGradeName == "12th" || selectedGradeName == "13th"' [class.active]="rshdForm.exam.value == 'NEET'" (click)="changeFormValue('exam', 'NEET')">
                                                        NEET
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-6">
                                                <div class="UNFAPP-form-fld-wrp ">
                                                    <button class="ns-cour-radiobx" *ngIf='selectedGradeName == "9th"|| selectedGradeName =="10th" ||selectedGradeName == "11th" || selectedGradeName == "12th" || selectedGradeName == "13th"' [class.active]="rshdForm.exam.value == 'JEEMAIN'" (click)="changeFormValue('exam', 'JEEMAIN')">
                                                        JEE
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.exam.value != ''">
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="State" class="nsonlinelabel">Select your State</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <select class="UNFAPP-form-fld" name="State" id="State" required="required" [value]="rescheduleFormControls.state.value" (change)="selectState($event)">
                                                    <option value="" disabled>Select State</option>
                                                    <option [value]="state?.name" *ngFor="let state of pincodefilteredStates">{{state?.name}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.state.value != ''">
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="City" class="nsonlinelabel">Select District</label>
                                            <div class="UNFAPP-form-fld-wrp">
                                                <select class="UNFAPP-form-fld" name="district" id="district" required="required" [value]="rescheduleFormControls.district.value" (change)="selectDistrict($event)">
                                                    <option value="" disabled>Select City</option>
                                                    <ng-container *ngIf="rescheduleFormControls.state.value != ''">
                                                        <option *ngFor="let district of pincodefilteredDistrict; let i=index" [value]="district?.districtName">
                                                            {{district?.districtName}}
                                                          </option>
                                                    </ng-container>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="City" class="nsonlinelabel">Select Exam City</label>
                                            <div class="UNFAPP-form-fld-wrp">
                                                <select class="UNFAPP-form-fld" name="City" id="City" required="required" [value]="rescheduleFormControls.city.value" (change)="selectCity($event)">
                                                    <option value="" disabled>Select City</option>
                                                    <ng-container>
                                                        <option *ngFor="let city of pincodefilteredCities; let i=index" [value]="city?.cityName">
                                                            {{city?.cityName}}
                                                          </option>
                                                    </ng-container>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.city.value != ''">
                                    <div class="col-md-12 col-lg-12 col-12">
                                        <label for="Targetexam" class="nsonlinelabel">Select Mode of exam</label>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="row">
                                            <div class="col-md-6 col-lg-6 col-6" *ngIf="filteredCenters?.length>0 && isOffline">
                                                <div class="UNFAPP-form-fld-wrp">
                                                    <button class="ns-cour-radiobx" [class.active]="rshdForm.mode.value == 'Offline'"
                                                    (click)="changeFormValue('mode', 'Offline')">Offline</button>
                                                </div>
                                            </div>
                                            <div class="col-md-6 col-lg-6 col-6" *ngIf="isOnline">
                                                <div class="UNFAPP-form-fld-wrp">
                                                    <button class="ns-cour-radiobx" [class.active]="rshdForm.mode.value == 'Online'"
                                                    (click)="changeFormValue('mode', 'Online')">Online</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.exam.value != '' && rescheduleFormControls.mode.value != '' && rescheduleFormControls.mode.value == 'Offline'">
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="Examcentre" class="nsonlinelabel">Select Exam Center</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <select class="UNFAPP-form-fld" name="Examcentre" id="Examcentre" required="required" [value]="rescheduleFormControls.center.value" (change)="centerChange($event)">
                                                    <option value="" disabled>Select Center</option>
                                                    <option [value]="center?.centerName" *ngFor="let center of filteredCenters">{{center?.centerName}}</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.center.value != ''">
                                    <div class="col-md-12 col-lg-12 col-12">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="Examcentre" class="nsonlinelabel">Center Address</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <p>{{centerAddress}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" *ngIf="rescheduleFormControls.mode.value === 'Offline' && rescheduleFormControls.center.value != ''">
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="date" class="nsonlinelabel">Date</label>
                                            <div class="UNFAPP-form-fld-wrp ">
                                                <select class="UNFAPP-form-fld" name="date" id="date" required="required" [value]="rshdForm.date.value" (change)="selectSlotDate($event)">
                                                    <option value="" disabled>Select Date</option>
                                                    <option [value]="dt" *ngFor="let dt of dates; let i = index">{{dt}} ({{dateDayarr[i]}})</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6 col-6">
                                        <div class="UNFAPP-form-fld-row">
                                            <label for="Time" class="nsonlinelabel">Time</label>
                                            <div class="UNFAPP-form-fld-wrp">
                                                <select class="UNFAPP-form-fld" name="time" id="time" required="required"  [value]="rshdForm.ruleid.value" (change)="selectSlotTime($event)">
                                                    <option value="" disabled>Select Time</option>
                                                    <option *ngFor="let tm of times[rshdForm.date.value]; let i = index" [value]="tm.ruleid">
                                                        {{tm.time}} - {{tm?.duration | date: 'hh:mm a'}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </ng-template>
            </div>
            <div class="IL_scac_go_home_btn" (click)="gotoHome()" *ngIf="step == 2; else step3Nav">
                Back to Home
            </div>
            <ng-template #step3Nav>
                <div class="step3_nav_btns">    
                    <div class="IL_scac_back_btn" (click)="goBack()">
                        Back
                    </div>
                  
                        <button class="IL_scac_reschedule_btn" (click)="rescheduleNow()" *ngIf="step == 3" [disabled]="rescheduleFormControls.scheduleid.value == ''">
                            Reschedule Test
                        </button>
                    
                </div>
            </ng-template>
        </div>
    </ng-container>

    <ng-container>
        <div class="row d-none">
            <div class="col-md-12 col-lg-12 col-12" id="hallTicket">
                <figure>
                    <img src="/assets/img/hallticket.png" width="100%" alt="">
                </figure>
                <table class="table table-bordered nsoff-stutable">
                    <thead>
                        <tr>
                            <th colspan="2" class="nsoff-hltckt">Hall Ticket</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Exam Name</td>
                            <td>{{hallTicketInfo?.exam}}</td>
                        </tr>
                        <tr>
                            <td style="width: 50%;">SCRI REF</td>
                            <td>{{hallTicketInfo?.hallticketNo}}</td>
                        </tr>
                        <tr>
                            <td>Mobile</td>
                            <td>{{userData?.phone}}</td>
                        </tr>
                        <tr>
                            <td>Full Name</td>
                            <td>{{userData?.firstName}} {{userData?.lastName}}</td>
                        </tr>
                        <tr>
                            <td>Grade</td>
                            <td>{{hallTicketInfo?.grade}} Class</td>
                        </tr>
                        <tr>
                            <td>State</td>
                            <td>{{hallTicketInfo.state}}</td>
                        </tr>
                        <tr>
                            <td>City</td>
                            <td>{{hallTicketInfo.city}}</td>
                        </tr>
                        <!-- <tr>
                            <td>Payment Status</td>
                            <td>
                                <p class="nsoffpaid">Paid - {{PaymentstatusUtility?.completedDetails?.amount/100
                                    |number :'1.2-2'}} Rs/- (inclusive of GST)</p>
                            </td>
                        </tr>
                        <tr>
                            <td>Transaction Ref</td>
                            <td>
                                <p class="nsofftran">{{PaymentstatusUtility?.completedDetails?.userOrderId}}</p>
                            </td>
                        </tr> -->
                        <tr>
                            <td>Exam Date</td>
                            <td>{{hallTicketInfo?.date |date}}</td>
                        </tr>
                        <tr>
                            <td>Time Slot</td>
                            <td>{{hallTicketInfo?.timeslot}} - {{hallTicketInfo?.examEndTime}}</td>
                        </tr>
                        <tr>
                            <td>Exam Center</td>
                            <td>{{hallTicketInfo?.center}}
                            </td>
                        </tr>
                        <tr>
                            <td>Exam Address</td>
                            <td>{{hallTicketInfo?.centerAddress}}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </ng-container>
        
                <ng-template #scorecomponent></ng-template>
                <ng-template #scorecomponentreport></ng-template>
      

</div>